import axios from "axios";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./ApplicationDetails.css";
import DashboardLayout from "./DashboardLayout ";

const ApplicationDetails = () => {

    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const { userEmail, userName, applicationId, candidateId, currentApplicationPage, jobId, currentApplicationPageSize } = location.state || {};
    const [candidate, setCandidate] = useState(null);
    const [job, setJob] = useState(null);
    const [navigateBack, setNavigateBack] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (navigateBack) {
            navigate(-1);
        }
    }, [navigateBack, navigate]);

    useEffect(() => {

        const fetchCandidate = async () => {
            try {
                const response = await axios.get(`${BASE_API_URL}/getUser?userId=${candidateId}`);
                setCandidate(response.data);
            } catch (error) {
            }
        };
        const fetchJob = async () => {
            try {
                const response = await axios.get(`${BASE_API_URL}/getJob?jobId=${jobId}`);
                setJob(response.data);
            } catch (error) {
            }
        };
        fetchCandidate();
        fetchJob();

    }, [candidateId, jobId, BASE_API_URL]);

    const handleBack = () => {
        navigate('/hr-dashboard/hr-applications/view-applications', { state: { userEmail, applicationId, userName, currentApplicationPage, jobId, currentApplicationPageSize } });
    };


    return (
        <DashboardLayout>
            <div className="main-content" style={{marginLeft:'10px'}}>
                <Button variant='primary' onClick={handleBack} style={{ width: '70px' }}>Back</Button>
                {job && (
                    <div className="jobdetails">
                        <h2>Job Details</h2>
                        <p><b>Job Title:</b> {job.jobTitle}</p>
                        <p><b>Job Type:</b> {job.jobType}</p>
                        <p><b>Requirements:</b> {job.skills}</p>
                        <p><b>Position:</b> {job.numberOfPosition}</p>
                        <p><b>Skills:</b> {job.skills}</p>
                        <p><b>Location:</b> {job.location}</p>
                        <b>Job Description:</b><pre className="job-details-text"> {job.jobsummary}</pre>
                    </div>
                )}
                {candidate && (
                    <div className="candidatedetails">
                        <h2>Candidate Details</h2>
                        <p><b>Name:</b> {candidate.userName}</p>
                        <p><b>Email:</b> {candidate.userEmail}</p>
                        <p><b>Phone:</b> {candidate.phone}</p>
                        <p><strong>Skills:</strong> {candidate.skills}</p>
                        <p><strong>Education:</strong> {candidate.education}</p>
                        <p>
                            <strong>Experience:</strong>
                            {candidate.experience ? (
                                `I have ${candidate.experience.yearsOfExperience} years of experience at ${candidate.experience.lastCompany} as a ${candidate.experience.jobRole}, and my responsibility is ${candidate.experience.jobDescription}.`
                            ) : (
                                "Fresher"
                            )}
                        </p>

                    </div>
                )}

            </div>

       
        </DashboardLayout>
    );
};

export default ApplicationDetails;
